<template>
  <v-container class="">
    <v-row>
      <h1 class="font-semibold text-xl mb-2">Leaderboard</h1>
      <v-spacer></v-spacer>
      <div>
        <v-select
          v-model="selectedCountry"
          :items="['Nigeria', 'Ghana', 'Kenya']"
          label="Country"
        />
      </div>
    </v-row>
    <!-- <v-btn color="primary">Select Date</v-btn> -->

    <v-card :loading="loadingData">
      <v-tabs v-model="mainTab">
        <v-tab>Leaderboard</v-tab>
        <v-tab>Leaderboard History</v-tab>
      </v-tabs>
      <div class="mt-5">
        <v-tabs color="primary" center-active v-model="leaderboardTab">
          <v-tab>Giftcard</v-tab>
          <v-tab>Crypto Sales</v-tab>
          <!-- <v-tab>Crypto Purchase</v-tab> -->
        </v-tabs>
      </div>
    </v-card>

    <v-tabs-items v-model="mainTab">
      <v-tab-item>
        <div class="mt-5">
          <v-tabs v-model="selection">
            <v-tab>Day</v-tab>
            <v-tab>Week</v-tab>
            <v-tab>Month</v-tab>
          </v-tabs>
        </div>
        <div class="mt-5">
          <v-card class="">
            <div class="mt-5 grey lighten-5">
              <v-row>
                <v-col cols="12" v-for="(user, i) in users" :key="i">
                  <div
                    class="d-flex w-100 justify-space-between align-center px-5"
                  >
                    <div class="d-flex">
                      <div class="mr-5">
                        <v-avatar
                          :color="getColorBg()"
                          :size="$vuetify.breakpoint.smAndDown ? 35 : 65"
                          >{{ user.firstName | getInitials }}
                        </v-avatar>
                      </div>
                      <div>
                        <h4
                          class="text-capitalize font-weight-medium text-md-body-1 text-lg-h6"
                        >
                          {{ user.firstName || '' }}
                          {{ user.lastName || '' }}.
                        </h4>
                        <p
                          :title="user.username"
                          class="subtitle-2 text-truncate"
                        >
                          {{
                            user.username
                              | trucateUsername($vuetify.breakpoint.mdAndUp)
                          }}
                        </p>
                      </div>
                    </div>
                    <div>
                      <div class="text-sm text-gray-700 text-right">
                        {{ getCurrencySymbol(selectedCountry)
                      }}{{ numberWithCommas(user.tradeAmount) }}
                      </div>
                      <div class="text-sm text-gray-700 text-right">
                        {{ user.amount | formatAmount }} points
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </div>
      </v-tab-item>
      <v-tab-item>
        <v-card class="px-4 py-3">
          <v-row>
            <v-col>
              <!--
                Bound through setDate rather than `v-model="dates[0]"`: Vue 2
                cannot detect an assignment to an array index, so writing the
                dates that way never notified the `dates` watcher and the
                range was never re-fetched.
              -->
              <v-text-field
                label="Start From"
                :value="dates[0]"
                @input="setDate(0, $event)"
                type="date"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="End At"
                :value="dates[1]"
                @input="setDate(1, $event)"
                type="date"
              ></v-text-field>
            </v-col>
          </v-row>
          <div class="mt-5 grey lighten-5">
            <v-row>
              <v-col
                cols="12"
                v-for="(user, i) in previousLeaderboard"
                :key="i"
              >
                <div
                  class="d-flex w-100 justify-space-between align-center px-5"
                >
                  <div class="d-flex">
                    <div class="mr-5">
                      <v-avatar
                        :color="getColorBg()"
                        :size="$vuetify.breakpoint.smAndDown ? 35 : 65"
                        >{{ user.firstName | getInitials }}
                      </v-avatar>
                    </div>
                    <div>
                      <h4
                        class="text-capitalize font-weight-medium text-md-body-1 text-lg-h6"
                      >
                        {{ user.firstName || '' }}
                        {{ user.lastName || '' }}.
                      </h4>
                      <p
                        :title="user.username"
                        class="subtitle-2 text-truncate"
                      >
                        {{
                          user.username
                            | trucateUsername($vuetify.breakpoint.mdAndUp)
                        }}
                      </p>
                    </div>
                  </div>
                  <div>
                    <div class="text-sm text-gray-700 text-right">
                      {{ getCurrencySymbol(selectedCountry)
                      }}{{ numberWithCommas(user.tradeAmount) }}
                    </div>
                    <div class="text-sm text-gray-700 text-right">
                      {{ user.amount | formatAmount }} points
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import dataApi from '../../api/systemData'
import { numberWithCommas } from '../../utils/helpers'
import { getCurrencySymbol } from '../../utils/countryHelpers'

export default {
  name: 'Leaderboard',
  data() {
    return {
      getCurrencySymbol,
      numberWithCommas,
      leaderboardTab: 0,
      data: {},
      users: [],
      // Both slots exist up front so $set writes stay positional - splicing
      // into an empty array would land "End At" in the "Start From" slot.
      dates: ['', ''],
      selection: 0,
      loadingData: false,
      mainTab: null,
      previousLeaderboard: [],
      selectedCountry: 'Nigeria'
    }
  },
  computed: {
    ...mapState({
      user: ({ user }) => user.user
    }),
    // `dates` always has two slots now, so its length no longer says whether
    // the admin actually picked a range - only both ends being filled does.
    hasDateRange() {
      return Boolean(this.dates[0] && this.dates[1])
    }
  },
  watch: {
    dates: {
      deep: true,
      handler() {
        // A half-filled range would send `to: ''` and come back empty.
        if (!this.hasDateRange) return
        this.getLeaderboardRange({
          category: this.leaderboardTab,
          period: this.selection
        })
      }
    },
    // Country has to refresh whichever list is actually on screen. It used to
    // always call getLeaderboard, which writes `users` (the Leaderboard tab),
    // so switching country while on Leaderboard History left
    // `previousLeaderboard` showing the previous country's rows.
    selectedCountry: function (newValue, oldValue) {
      if (newValue === oldValue) return
      this.getLeaderboard({
        category: this.leaderboardTab,
        period: this.selection
      })
      // Both tabs are country-scoped, so refresh the range list too when one
      // is in play - same as the leaderboardTab watcher does.
      if (this.hasDateRange) {
        this.getLeaderboardRange({
          category: this.leaderboardTab,
          period: this.selection
        })
      }
    },
    leaderboardTab: function (newValue, oldValue) {
      // 0 - Giftcard
      // 1 - Coin Sale
      // 2 - Coin Purchase
      if (oldValue !== newValue) {
        this.getLeaderboard({
          period: this.selection,
          category: this.leaderboardTab
        })
        if (this.hasDateRange) {
          this.getLeaderboardRange({
            category: this.leaderboardTab
          })
        }
      }
    },
    selection: function (newValue, oldValue) {
      // 0 = Day
      // 1 - Week
      // 2 - Month
      // 3 -Year
      if (oldValue !== newValue)
        if (this.hasDateRange) {
          this.getLeaderboardRange({
            category: this.leaderboardTab
          })
        } else {
          this.getLeaderboard({
            period: this.selection,
            category: this.leaderboardTab
          })
        }
    }
  },
  filters: {
    trucateUsername(value, breakpoint) {
      if (!value) return ''
      if (breakpoint) return value
      return value.length > 10
        ? `${value.toString().substring(0, 14)}...`
        : value
    },
    getInitials(value) {
      if (!value) return 'AA'
      return value[0]
    },
    formatAmount(value) {
      if (!value) return 0
      return Number.parseFloat(value).toFixed(2)
    }
  },
  created() {
    this.getLeaderboard({
      period: this.selection,
      category: this.leaderboardTab
    })
  },
  methods: {
    // $set is what makes the write observable; a plain `dates[i] = value`
    // is invisible to Vue 2 and leaves the watcher (and the list) stale.
    setDate(index, value) {
      this.$set(this.dates, index, value || '')
    },
    async getLeaderboardRange({ category }) {
      this.loadingData = true
      const categoryText = category === 0 ? 'giftcard' : 'coin'
      // const typeText = category === 0 ? 'sale' : 'purchase'
      const typeText = category === 0 || category === 1 ? 'sale' : 'purchase'
      const res = await dataApi.data().getLeaderboard({
        category: categoryText,
        type: typeText,
        requester: 'admin',
        from: this.dates[0],
        to: this.dates[1],
        country: this.selectedCountry
      })

      this.previousLeaderboard = res.data.data.leaderboard

      this.loadingData = false
    },
    async getLeaderboard({ period, category }) {
      this.loadingData = true
      const periodText =
        period === 0
          ? 'day'
          : period === 1
          ? 'week'
          : period === 2
          ? 'month'
          : 'day'
      const categoryText = category === 0 ? 'giftcard' : 'coin'
      // const typeText = category === 0 ? 'sale' : 'purchase'
      const typeText = category === 0 || category === 1 ? 'sale' : 'purchase'

      const res = await dataApi.data().getLeaderboard({
        period: this.hasDateRange ? undefined : periodText || 'day',
        category: categoryText,
        type: typeText,
        requester: 'admin',
        country: this.selectedCountry
      })

      this.users = res.data.data.leaderboard

      this.loadingData = false
    },
    getColorBg() {
      const colors = [
        'primary',
        'accent',
        'pink',
        'brown',
        'green',
        'purple',
        'yellow',
        'red',
        'indigo',
        'blue',
        'light-blue',
        'teal',
        'cyan',
        'green',
        'light-green',
        'lime',
        'amber',
        'orange',
        'blue-grey'
      ]
      return colors[Math.floor(Math.random() * colors.length)]
    }
  }
}
</script>
